var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"item-text":"name","item-value":"id","items":_vm.searchResults,"label":"Unidade de Medida","dense":"","value":_vm.selectedValue,"hide-details":"auto","return-object":""},on:{"input":function($event){return _vm.setSelectedValue($event)}},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
var attrs = ref.attrs;
var on = ref.on;
return [_c('v-list-item',_vm._g(_vm._b({},'v-list-item',attrs,false),on),[_vm._v(" "+_vm._s(item.symbol)+" | "+_vm._s(item.name)+" ")])]}},{key:"selection",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.symbol)+" | "+_vm._s(item.name)+" ")]}}])},[_vm._v(" > ")])}
var staticRenderFns = []

export { render, staticRenderFns }